/**
 * The market row extras (M4 spec §12.3, §15 item 3): a stock bar, a trend arrow and the price cause chip with the
 * cause text in its tooltip. Each pairs its tone with a glyph and words (style guide §9.5).
 */
import type { ReactNode } from 'react'
import type { CauseChipModel, RowEconomy, StockModel, TrendModel } from './causeModel'
import './strategic.css'

export function CauseChip(p: { chip: CauseChipModel }): ReactNode {
  const { chip } = p
  return (
    <span className="sui-chip" data-tone={chip.tone} data-tag={chip.tag} title={chip.tooltip} aria-label={`${chip.tagLabel}: ${chip.tooltip}`}>
      <span className="sui-chip__pct">{chip.label}</span> <span className="sui-chip__tag">{chip.tagLabel}</span>
    </span>
  )
}

export function StockBar(p: { stock: StockModel }): ReactNode {
  const { stock } = p
  return (
    <span className="sui-stock" data-tone={stock.tone} title={stock.detail}>
      <span className="sui-stock__bar" aria-hidden="true">
        <span className="sui-stock__fill" style={{ transform: `scaleX(${stock.fill})` }} />
      </span>
      <span className="sui-stock__label">{stock.label}</span>
    </span>
  )
}

export function TrendArrow(p: { trend: TrendModel }): ReactNode {
  return (
    <span className="sui-trend" data-tone={p.trend.tone} title={p.trend.label} aria-label={p.trend.label}>
      {p.trend.glyph}
    </span>
  )
}

/** The three extras of one market row, or nothing outside the strategic economy. */
export function RowEconomyCells(p: { economy: RowEconomy | undefined }): ReactNode {
  const e = p.economy
  if (e === undefined) return null
  return (
    <span className="sui-economy" data-testid="market-economy">
      <StockBar stock={e.stock} />
      <TrendArrow trend={e.trend} />
      {e.cause !== null ? <CauseChip chip={e.cause} /> : null}
    </span>
  )
}
